import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { TourGateStatusE } from "../../models/enums";

export const selectProductTourCurrentStep = createSelector(
    (state: RootState) => state.productTour.currentStep,
    currentStep => currentStep
);

export const selectProductTourInitialStep = createSelector(
    (state: RootState) => state.productTour.initialStep,
    initialStep => initialStep
);

export const selectTourGateStatus = createSelector(
    (state: RootState) => state.productTour.gateStatus,
    gateStatus => gateStatus
);

/**
 * True once the welcome message / tour has left the screen (or was never going to appear), which is
 * the point at which another overlay may safely open.
 */
export const selectIsTourGateCleared = createSelector(
    (state: RootState) => state.productTour.gateStatus,
    gateStatus => gateStatus === TourGateStatusE.Cleared
);